/**
 * Client-side CRM push.
 *
 * Fire-and-forget: a CRM outage must never break a form submission. The edge
 * function owns all credentials and the score / tier / booking-intent mapping.
 */
import { supabase } from "@/integrations/supabase/client";
import { attributionProps } from "@/lib/utm";

export type CrmEvent =
  | "masterclass_registration"
  | "strategy_session_application"
  | "built_index_lead"
  | "built_index_complete"
  | "built_index_unlock"
  | "fsap_intake"
  | "compassion_enrollment"
  | "purchase"
  | "newsletter_subscribe";

export interface CrmLeadInput {
  event: CrmEvent;
  email: string;
  fullName?: string | null;
  phone?: string | null;
  organization?: string | null;
  role?: string | null;
  source?: string | null;
  builtTotal?: number | null;
  builtTier?: string | null;
  discType?: string | null;
  loveFuel?: string | null;
  loveDrain?: string | null;
  lovinScore?: number | null;
  lovinTier?: string | null;
  amountCents?: number | null;
  priceId?: string | null;
  paid?: boolean | null;
  budget?: string | null;
  timeline?: string | null;
  decisionAuthority?: string | null;
  focus?: string | null;
  notes?: string | null;
  tags?: string[];
}

/** Push one lead event to the CRM / email automation stack. Never throws. */
export function syncLeadToCrm(input: CrmLeadInput): void {
  if (!input.email || !input.email.includes("@")) return;

  void supabase.functions
    .invoke("crm-sync", {
      body: {
        ...input,
        email: input.email.trim().toLowerCase(),
        page: typeof window === "undefined" ? null : window.location.pathname,
        attribution: attributionProps(),
      },
    })
    .then(({ error }) => {
      if (error && import.meta.env.DEV) console.debug("[crm-sync]", input.event, error.message);
    });
}
